
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 20.002 20.003"}, attrs),
              ...rest,
            },
            children.concat([_c('defs',[_c('clipPath',{attrs:{"id":"clip-path-onboard-noti"}},[_c('rect',{attrs:{"id":"Rectangle_15173","data-name":"Rectangle 15173","width":"20.002","height":"20.003","fill":"none"}})])]),_c('g',{attrs:{"id":"Group_45281","data-name":"Group 45281"}},[_c('g',{attrs:{"id":"Group_45280","data-name":"Group 45280","clip-path":"url(#clip-path-onboard-noti)"}},[_c('path',{attrs:{"id":"Path_32391","data-name":"Path 32391","d":"M19.457 12.972l-1.986-7.138a7.953 7.953 0 00-15.431.407L.508 13.133a3.139 3.139 0 003.065 3.821H5.68a4.664 4.664 0 008.75 0h2a3.145 3.145 0 003.027-3.977zm-8.811 5.251a2.95 2.95 0 01-3.058-1.274h4.94a2.943 2.943 0 01-1.88 1.274zm6.793-3.406a1.423 1.423 0 01-1.01.418H3.574a1.425 1.425 0 01-1.392-1.728V13.5l1.532-6.89a6.24 6.24 0 0112.107-.31l2.007 7.232a1.478 1.478 0 01.027.281 1.422 1.422 0 01-.417 1.01z","fill":"#262626"}})])])])
          )
        }
      }
    